import { useMutation, useQuery } from "react-query";
import {
  assignManagerManual,
  createManagerRule,
  getManagerRules,
  deleteManagerRule,
  reapplyManagerRules,
  addManagersToEmployees,
  removeEmployeeManager,
  syncEmployeeManagers,
  getEmployeeManagers,
} from "../api/managerAssignment";
import { queryClient } from "./client";

export function useGetManagerRules() {
  return useQuery({
    queryKey: "managerRules",
    queryFn: getManagerRules,
  });
}

export function useCreateManagerRule() {
  return useMutation({
    mutationFn: createManagerRule,
    onSuccess: () => {
      queryClient.invalidateQueries("managerRules");
      queryClient.invalidateQueries("employeesOverview");
    },
  });
}

export function useDeleteManagerRule() {
  return useMutation({
    mutationFn: deleteManagerRule,
    onSuccess: () => {
      queryClient.invalidateQueries("managerRules");
      queryClient.invalidateQueries("employeesOverview");
    },
  });
}

export function useAssignManagerManual() {
  return useMutation({
    mutationFn: assignManagerManual,
    onSuccess: () => {
      queryClient.invalidateQueries("employeesOverview");
    },
  });
}

export function useReapplyManagerRules() {
  return useMutation({
    mutationFn: reapplyManagerRules,
    onSuccess: () => {
      queryClient.invalidateQueries("employeesOverview");
    },
  });
}

export function useAddManagersToEmployees() {
  return useMutation({
    mutationFn: addManagersToEmployees,
    onSuccess: () => {
      queryClient.invalidateQueries("employeesOverview");
    },
  });
}

export function useRemoveEmployeeManager() {
  return useMutation({
    mutationFn: removeEmployeeManager,
    onSuccess: () => {
      queryClient.invalidateQueries("employeesOverview");
    },
  });
}

export function useSyncEmployeeManagers() {
  return useMutation({
    mutationFn: syncEmployeeManagers,
    onSuccess: () => {
      queryClient.invalidateQueries("employeesOverview");
    },
  });
}

export function useGetEmployeeManagers(employeeId: string) {
  return useQuery({
    queryKey: ["employeeManagers", employeeId],
    queryFn: () => getEmployeeManagers(employeeId),
    enabled: !!employeeId,
  });
}
